import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import {
    bindUserStateManager,
    injectUserStateManager,
    TYPES as CONTROLLER_TYPES,
    unbindUserStateManager,
} from '../interface/bind';
import type { IUserStateInstantiator } from '../interface/userstate';
import userState from './userState';

function _build(container: IContainer): Readonly<IUserStateInstantiator> {
    return Object.freeze({
        open: (name: string) => userState.load(name),
        expand: (data: string) => userState.expand(data),
    });
}

export default buildBindable<IUserStateInstantiator>({
    id: CONTROLLER_TYPES.IUserStateManager,
    bind: bindUserStateManager,
    remove: unbindUserStateManager,
    build: container => Promise.resolve(_build(container)),
    inject: injectUserStateManager,
});
